/**
 * Reply to a specific message — the one client lever (2026-09-15). Build-time:
 * `REACT_APP_MESSAGE_REPLIES=off` hides the reply button, the composer's
 * "replying to" strip and the quoted block on every bubble; anything else =
 * on. The server accepts the field regardless (additive), so a message that
 * already carries a `replyTo` simply renders without its quote while the
 * lever is off — nothing is lost, and flipping back shows it again.
 */
export function messageRepliesEnabled(env: Record<string, string | undefined> = process.env): boolean {
  return String(env.REACT_APP_MESSAGE_REPLIES ?? '').trim().toLowerCase() !== 'off';
}
